import { swrConfig } from "config/swr";
import { SWRConfig } from "swr";

function SWRConfigProvider({ children }: { children?: React.ReactNode }) {
  return <SWRConfig value={swrConfig}>{children}</SWRConfig>;
}
export default SWRConfigProvider;
